import { render } from "./CosmoRotateApps.vue?vue&type=template&id=156f01bd&scoped=true"
import script from "./CosmoRotateApps.vue?vue&type=script&lang=js"
export * from "./CosmoRotateApps.vue?vue&type=script&lang=js"

import "./CosmoRotateApps.vue?vue&type=style&index=0&id=156f01bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156f01bd"]])

export default __exports__